import test1 from "@frog/source/tests/Keyset.test.js"
import test2 from "@frog/source/tests/skills/skills.test.js"
import test3 from "@frog/source/tests/skills/longrange.skills.test.js"
import test4 from "@frog/source/tests/skills/counterattack.skills.test.js"

let tests = []
tests = tests.concat(test1)
tests = tests.concat(test2)
tests = tests.concat(test3)
tests = tests.concat(test4)

// var context = require.context("@frog/source/tests", false, /.test.js$/)
// const testss = context.keys().map((key) => {
//     const tests = context(key).default
//     tests = tests.concat(tests)
//     return tests
// })

export default tests
